import { CvssVersion, safeParseCvssVector } from '@ics-portal/cvss';
import { type Maybe } from '@models/Maybe';
import {
    type CveCvssVersionScore,
    CvssVersionLabel,
} from '@components/cve/cve-details/types';

const CVSS_VERSION_TO_LABEL: Record<CvssVersion, CvssVersionLabel> = {
    [CvssVersion.CVSS20]: CvssVersionLabel.V2,
    [CvssVersion.CVSS30]: CvssVersionLabel.V30,
    [CvssVersion.CVSS31]: CvssVersionLabel.V31,
    [CvssVersion.CVSS40]: CvssVersionLabel.V40,
};

const ALL_VERSION_LABELS = [
    CvssVersionLabel.V40,
    CvssVersionLabel.V31,
    CvssVersionLabel.V30,
    CvssVersionLabel.V2,
];

function emptyVersionScore(version: CvssVersionLabel): CveCvssVersionScore {
    return {
        version,
        overallScore: null,
        baseScore: null,
        impact: null,
        exploitability: null,
        temporalScore: null,
        environmental: null,
        modifiedImpact: null,
        vector: null,
    };
}

export function parseCveVersionScores(
    vector: Maybe<string>,
): CveCvssVersionScore[] {
    const parsed = vector ? safeParseCvssVector(vector) : null;

    if (!parsed?.success) {
        return ALL_VERSION_LABELS.map(emptyVersionScore);
    }

    const { score } = parsed;
    const activeLabel = CVSS_VERSION_TO_LABEL[score.version];

    return ALL_VERSION_LABELS.map((version) => {
        if (version !== activeLabel) return emptyVersionScore(version);

        return {
            version,
            overallScore: score.overallScore,
            baseScore: score.baseScore,
            impact: score.impactSubscore,
            exploitability: score.exploitabilitySubscore,
            temporalScore: score.temporalScore,
            environmental: score.environmentalScore,
            modifiedImpact: score.modifiedImpactSubscore,
            vector,
        };
    });
}
